// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const latias: PokeData = {
  "id": 380,
  "name": "latias",
  "height": 14,
  "weight": 400,
  "base_experience": 270,
  "types": [
    PokeType.DRAGON,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "confusion",
    "psychic",
    "recover",
    "psywave",
    "charm",
    "safeguard",
    "dragon-breath",
    "helping-hand",
    "wish",
    "refresh",
    "mist-ball",
    "water-sport",
    "healing-wish",
    "tailwind",
    "psycho-shift",
    "dragon-pulse",
    "zen-headbutt",
    "guard-split",
    "stored-power",
    "heal-pulse",
    "reflect-type"
  ],
  "moves": [
    "psychic",
    "psywave",
    "dragon-breath",
    "refresh",
    "healing-wish",
    "tailwind",
    "dragon-pulse",
    "zen-headbutt",
    "kinesis",
    "prismatic-cage",
    "inner-spirit",
    "psy-ball",
    "draco-meteor"
  ],
  "evolution_chain": {
    "id": 196,
    "item": null,
    "species": [
      {
        "name": "latias",
        "order": 410,
        "types": [
          PokeType.DRAGON,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 121,
    "speed": 140,
    "ability_power": 140
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
